"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ARManager_defaultLogoStatic;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARManager = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
class ARManager {
    constructor(renderingEngine) {
        this._eventEngine = viewer_shared_services_1.EventEngine.instance;
        this._systemInfo = viewer_shared_services_1.SystemInfo.instance;
        this._uuidGenerator = viewer_shared_services_1.UuidGenerator.instance;
        _ARManager_defaultLogoStatic.set(this, "https://viewer.shapediver.com/v3/graphics/logo.png");
    }
    init() { }
    isMobileDeviceWithoutBrowserARSupport() {
        // has to be a mobile device (duh)
        if (this._systemInfo.isIOS === false &&
            this._systemInfo.isAndroid === false)
            return false;
        // no Firefox on Android
        if (this._systemInfo.isAndroid === true &&
            this._systemInfo.isFirefox === true)
            return true;
        // no Instagram on iOS
        if (this._systemInfo.isIOS === true &&
            this._systemInfo.isInstagram === true)
            return true;
        return false;
    }
    viewInAR(file_1) {
        return __awaiter(this, arguments, void 0, function* (file, options = { arScale: "auto", arPlacement: "floor", xrEnvironment: false }) {
            const eventId = this._uuidGenerator.create();
            const event = {
                type: viewer_shared_types_1.TASK_TYPE.AR_LOADING,
                id: eventId,
                progress: 0,
                status: "Loading AR scene",
            };
            this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_START, event);
            // if this is not a supported device, throw an error
            if (this.viewableInAR() === false) {
                const event = {
                    type: viewer_shared_types_1.TASK_TYPE.AR_LOADING,
                    id: eventId,
                    progress: 1,
                    status: "Stopped AR loading due to an error",
                };
                this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_CANCEL, event);
                throw new viewer_shared_services_1.ShapeDiverViewerArError(
                // eslint-disable-next-line quotes
                'Api.viewInAR: The device or browser is not supported for this functionality, please call "viewableInAR" for more information.');
            }
            const arScale = options.arScale !== "auto" ? "fixed" : "auto";
            // const arPlacement = options.arPlacement !== 'wall' ? 'floor' : 'wall';
            // const xrEnvironment = options.xrEnvironment !== true ? false : true;
            // let arEnvironment = '';
            // const envMapUrl = this.getEnvironmentMapImageUrl();
            // if (envMapUrl !== '') {
            //   if (envMapUrl.endsWith('.hdr')) {
            //     arEnvironment = 'skybox-image=' + envMapUrl;
            //   } else {
            //     arEnvironment = 'environment-image=' + envMapUrl;
            //   }
            // }
            if (this._systemInfo.isIOS) {
                // create the link and click it
                const a = document.createElement("a");
                a.href =
                    file +
                        (arScale === "fixed"
                            ? ".usdz_allowsContentScaling=0"
                            : ".usdz");
                a.rel = "ar";
                const img = document.createElement("img");
                img.src = __classPrivateFieldGet(this, _ARManager_defaultLogoStatic, "f");
                a.appendChild(img);
                a.click();
            }
            else {
                const a = document.createElement("a");
                a.href = `intent://arvr.google.com/scene-viewer/1.0?resizable=${arScale === "fixed" ? "false" : "true"}&file=${file}&mode=ar_only#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;end;`;
                a.click();
            }
            const event2 = {
                type: viewer_shared_types_1.TASK_TYPE.AR_LOADING,
                id: eventId,
                progress: 1,
                status: "Done loading AR scene, launching AR",
            };
            this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.TASK.TASK_END, event2);
        });
    }
    viewableInAR() {
        // has to be a mobile device (duh)
        if (this._systemInfo.isIOS === false &&
            this._systemInfo.isAndroid === false)
            return false;
        // no Firefox on Android
        if (this._systemInfo.isAndroid === true &&
            this._systemInfo.isFirefox === true)
            return false;
        // no Firefox on iOS
        if (this._systemInfo.isIOS === true &&
            this._systemInfo.isFirefox === true)
            return false;
        // no Instagram on iOS
        if (this._systemInfo.isIOS === true &&
            this._systemInfo.isInstagram === true)
            return false;
        return true;
    }
}
exports.ARManager = ARManager;
_ARManager_defaultLogoStatic = new WeakMap();
//# sourceMappingURL=ARManager.js.map